// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  firebase  :  { 

    apiKey :  "AIzaSyDgSh_hlbtw5EwZM4R5bZwnHPsKy8lHqoo" , 
  
    authDomain :  "lsm-app-e5eeb.firebaseapp.com" , 
  
    projectId :  "lsm-app-e5eeb" , 
  
    storageBucket :  "lsm-app-e5eeb.appspot.com" , 
  
    messagingSenderId :  "88757290879" , 
  
    appId :  "1:88757290879:web:7c85d21f75f5f204c83c4a" , 
  
    measurementId :  "G-EQ16LHLV3X" 
  
  }
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
